<template>
  <div class="login">
    <Form class="form">
      <div class="title">欢迎登录艺棒小匠</div>
      <div class="login-type">
        <div class="login-btn" :class="{active:loginType === 1}" @click="loginType = 1">
          密码登录
        </div>
        <div class="login-btn" :class="{active:loginType === 2}" @click="loginType = 2">
          短信登录
        </div>
      </div>
      <FormItem class="input-view" style="margin-top: 50px">
        <i-input   placeholder="请输入您的手机号"  name="phone" number  :maxlength="11" v-model="loginForm.phone">
          <span slot="prefix">
              <img src="../../assets/images/mobile.png" alt class="icon">
          </span>
        </i-input>
      </FormItem>
      <FormItem class="input-view" v-if="loginType === 1">
        <i-input placeholder="请输入密码" name="password" :maxlength="16" type="password" v-model="loginForm.password">
           <span slot="prefix">
              <img src="../../assets/images/lock.png" alt class="icon">
          </span>
        </i-input>
      </FormItem>
      <FormItem class="input-view" v-if="loginType === 2">
        <i-input placeholder="请输入验证码" style="width: 230px" v-model="loginForm.code"></i-input>
        <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCode()" :disabled="!show">
          <span v-if="show">获取验证码</span>
          <span v-if="!show">{{count}} s</span>
        </Button>
      </FormItem>
      <Button type="primary" style="width: 100%;height: 48px;border-radius: 24px;margin-top: 40px" @click="login()">登录
      </Button>
      <div class="other">
        <span @click="$router.push({name:'forward'})">忘记密码</span>
        <Divider type="vertical"></Divider>
        <span @click="$router.push({name:'register'})">立即注册</span>
      </div>
    </Form>
  </div>
</template>

<script>
import { isMobile } from '@/libs/validator'

export default {
  name: 'login',
  data () {
    return {
      show: true,
      count: 60,
      timer: null,
      loginType: 1,
      loginForm: {
        phone: '',
        password: '',
        code: ''
      }
    }
  },
  methods: {
    getCode () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }

      if (!this.timer) {
        this.$request('610796cfa73ad', {
          phone: this.loginForm.phone + '',
          type: 'user_login'
        }).then(res => {
          this.show = false
          this.count = 60
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        })
      } else {
        return this.$message.error('请求验证码频繁')
      }
    },
    login () {
      switch (this.loginType) {
        case 1:
          this.loginRemoteByPassword()
          break
        case 2:
          this.loginRemoteByCode()
          break
      }
    },
    loginRemoteByPassword () {
      if (!this.loginForm.phone) {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (!this.loginForm.password) {
        return this.$message.error('请输入密码')
      }
      this.$request('6107b00aebb71', {
        phone: this.loginForm.phone + '',
        password: this.loginForm.password
      }).then(res => {
        localStorage.setItem('USERINFO', JSON.stringify(res.data.data.data))
        localStorage.setItem('apiAuth', res.data.data.api_auth)
        this.$store.dispatch('login', res.data.data)
        this.$router.push('/')
        console.log(res.data)
      })
    },
    loginRemoteByCode () {
      if (!this.loginForm.phone) {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('手机号验证失败')
      }
      if (!this.loginForm.code) {
        return this.$message.error('请输入验证码')
      }
      this.$request('6107a27a6b3fc', {
        phone: this.loginForm.phone + '',
        code: this.loginForm.code
      }).then(res => {
        this.$store.dispatch('login', res.data.data)
        this.$store.dispatch('getUserInfo')

        this.$router.push('/')
      })
    }
  }
}
</script>

<style scoped lang="less">
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  flex: 1;
  background-image: url("../../assets/images/loginbg.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .form {
    width: 480px;
    background-color: #FFFFFF;
    border-radius: 28px;
    padding: 60px 40px;

    .title {
      font-weight: 600;
      font-size: 30px;
      line-height: 50px;
    }

    .login-type {
      width: 100%;
      border-bottom: 1px solid #F7F7F7;
      display: flex;
      margin-top: 20px;

      .login-btn {
        height: 50px;
        line-height: 50px;
        margin-right: 30px;
        font-weight: 400;
        font-size: 18px;
        cursor: pointer;
      }

      .active {
        color: #FB9E2F;
        font-weight: 600;
        position: relative;

        &:after {
          content: '';
          width: 70px;
          height: 2px;
          background-color: #FB9E2F;
          position: absolute;
          bottom: -0.5px;
          left: 0;
        }
      }
    }

    .input-view {
      margin-top: 30px;

      .icon {
        width: 24px;
        margin-top: 7px;
      }
    }
  }

  .other {
    display: flex;
    margin-top: 30px;
    justify-content: flex-end;
    align-items: center;

    span {
      cursor: pointer;
      color: #979797;
    }
  }
}
</style>
